import React, { useState, useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from "react-router-dom";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "../../../scss/index.scss";
import { estiloColores } from "../../../estilos/colores";
import Swal from "sweetalert2";
import {
  activo,
  inactivo,
  tu_nuevo_estado_sera,
  vas_a_cambiar_el_estado_de_tu_vehiculo,
  si,
  cancelar,
  cambio_de_estado_completado_con_exito,
  ahora_tu_estado_es,
} from "../../../utils/traductor";
import { ENTORNO } from "../../../utils/constantes";
import {
  setmenuAbajoSeleccionado,
  setmenuLateralSeleccionado,
  getEstadoConductor,
  setEstadoConductor,
} from "../../../utils/variablesLocales";
import { apiUsuario } from "../../../api/usuario";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import Fab from "@mui/material/Fab";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LogoutIcon from "@mui/icons-material/Logout";
import Box from "@mui/material/Box";
import { vas_a_cerrar_la_sesion } from "../../../utils/traductor";

const apiusuario = new apiUsuario();

const StyledFab = styled(Fab)({
  position: "absolute",
  zIndex: 1,
  top: -30,
  left: 0,
  right: 0,
  margin: "0 auto",
});

export function BarraNavegacionyMenuLateral() {
  // const [EstaConectado, setEstaConectado] = useState(false);

  const navigate = useNavigate();

  const seleccionoCambiarEstado = async (e) => {
    setmenuAbajoSeleccionado("CambiarEstado");
    setmenuLateralSeleccionado("");

    Swal.fire({
      title: vas_a_cambiar_el_estado_de_tu_vehiculo,
      text:
        tu_nuevo_estado_sera +
        " " +
        (getEstadoConductor() === "Activo" ? inactivo : activo),
      // type: "warning",
      showCancelButton: true,
      confirmButtonText: si,
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: cancelar,
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        if (getEstadoConductor() === "Inactivo") {
          setEstadoConductor("Activo");
          CambiarEstadoConductor("Activo");
        } else {
          setEstadoConductor("Inactivo");
          CambiarEstadoConductor("Inactivo");
        }

        setmenuAbajoSeleccionado("Inicio");
        navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");

        Swal.fire({
          // type: "success",
          title: cambio_de_estado_completado_con_exito,
          text:
            ahora_tu_estado_es +
            " " +
            (getEstadoConductor() === "Activo" ? activo : inactivo),
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    });
  };

  const CambiarEstadoConductor = async (Estado) => {
    if (Estado === "Activo") {
      await apiusuario.activarConductor();
    } else {
      await apiusuario.inactivarConductor();
    }
  };

  const Billetera = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Conductor/Billetera");
  };

  const MisViajes = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Conductor/MisViajes");
  };

  const CerrarSesion = async () => {
    Swal.fire({
      title: vas_a_cerrar_la_sesion,
      text: "",
      // type: "warning",
      showCancelButton: true,
      confirmButtonText: si,
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: cancelar,
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
      }
    });
  };

  return (
    <AppBar position="fixed" color="primary" sx={{ top: "auto", bottom: 0 }}>
      <Toolbar style={{ background: "white", color: "#153B5E" }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={(e) => Billetera(e)}
        >
          <AccountBalanceWalletIcon />
        </IconButton>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={(e) => MisViajes(e)}
        >
          <CalendarMonthIcon />
        </IconButton>
        {getEstadoConductor() === "Inactivo" ? (
          <StyledFab
            style={{ background: estiloColores.Rojo, color: "white" }}
            onClick={(e) => seleccionoCambiarEstado(e)}
            aria-label="add"
          >
            <LocalTaxiIcon />
          </StyledFab>
        ) : (
          <StyledFab
            style={{ background: estiloColores.Verde, color: "white" }}
            onClick={(e) => seleccionoCambiarEstado(e)}
            aria-label="add"
          >
            <LocalTaxiIcon />
          </StyledFab>
        )}
        <Box sx={{ flexGrow: 1 }} />
        {/* {getEstadoConductor() === "Inactivo" ? (
          <div style={{ color: estiloColores.Rojo }}>
            {getEstadoConductor() === "Activo" ? activo : inactivo}
          </div>
        ) : (
          <div style={{ color: estiloColores.Verde }}>
            {getEstadoConductor() === "Activo" ? activo : inactivo}
          </div>
        )} */}
        <IconButton color="inherit" onClick={(e) => CerrarSesion(e)}>
          <LogoutIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
